import { HiArrowLongRight } from "react-icons/hi2";
import { useHistory } from "react-router-dom";
import { Profile } from "../../../Components/MiniProfile/Profile/profile";

import "./bullets.sass";
import { miniProfileTranslate } from "../../../i18n/translatedMessages";

export default function MiniProfile() {
  const history = useHistory();

  const handleClick = () => {
    history.push("/candidate");
  };

  return (
    <div className="container-fluid p-5 position-absolute bg-white" style={{ top: 0, left: 0, zIndex: 9999, width: "100vw", height: "100vh" }}>
      <div className="row px-5">
        <div className="col flex flex-column justify-content-center">
          <h4 className="text-purple">
            <span className="fw-bold me-2">{miniProfileTranslate.miniProfileText1}</span>
            {miniProfileTranslate.miniProfileText2}
          </h4>

          <div className="mt-3">
            <p>{miniProfileTranslate.miniProfileText3}</p>
            <ul className="bullets">
              <li className="mt-1 fw-bold">{miniProfileTranslate.miniProfileText4}</li>
              <li className="mt-1 fw-bold">{miniProfileTranslate.miniProfileText5}</li>
              <li className="mt-1 fw-bold">{miniProfileTranslate.miniProfileText6}</li>
            </ul>
          </div>
          <div className="mt-3">
            <p>Beneficios Exclusivos</p>
            <ul className="bullets">
              <li className="fw-bold mt-1">{miniProfileTranslate.miniProfileText7}</li>
              <li className="fw-bold mt-1">{miniProfileTranslate.miniProfileText8}</li>
              <li className="fw-bold mt-1">{miniProfileTranslate.miniProfileText9}</li>
            </ul>
          </div>
          <div className="mt-4">
            <span>¡{miniProfileTranslate.miniProfileText10}</span>
          </div>
          <button onClick={handleClick} className="btn bg-purple text-white rounded-pill px-4 py-2 mt-4">
            {miniProfileTranslate.miniProfileBtn} <HiArrowLongRight />
          </button>
        </div>
        <div className="col-8">
          <Profile />
        </div>
      </div>
    </div>
  );
}
